<template>
  <div class="home">
    <HeaderComponent/>
    <MainCarousel/>
    <Packages/>
    <HowToRecharge/>
    <CorporateTopUp/>
    <About/>
    <Contact/>
    <FooterComponent/>
    <LoginModal/>
    <ForgotModal/>
    <RegisterModal/>
    <GuestModal/>
    <ContactModal/>
  </div>
</template>

<script>
import HeaderComponent from '../components/Header.vue';
import MainCarousel from '../components/Banner.vue';
import Packages from '../components/Packages.vue';
import HowToRecharge from '../components/HowToRecharge';
import Contact from '../components/Contact.vue';
import FooterComponent from '../components/Footer.vue';
import LoginModal from "../components/LoginModal";
import ForgotModal from "../components/ForgotModal";
import RegisterModal from "../components/RegisterModal";
import CorporateTopUp from "../components/CorporateTopUp";
import About from "../components/About";
import GuestModal from "../components/GuestModal";
import ContactModal from "../components/ContactModal";

export default {
  name: 'Home',
  components: {
    ContactModal,
    GuestModal,
    RegisterModal,
    LoginModal,
    ForgotModal,
    HowToRecharge,
    HeaderComponent,
    MainCarousel,
    Packages,
    Contact,
    FooterComponent,
    CorporateTopUp,
    About
  }
}
</script>
